import { Box } from "@mantine/core";
import type { CSSProperties } from "react";

type TabCountBadgeProps = {
  count: number | null | undefined;
  /** Pin to the top-right corner of a `position: relative` parent instead of flowing inline. */
  floating?: boolean;
  label?: string;
  style?: CSSProperties;
};

/** Red unread / pending count pill for tabs and nav items. Renders nothing for 0. */
export default function TabCountBadge({ count, floating = false, label, style }: TabCountBadgeProps) {
  if (!count || count <= 0) return null;
  const text = count > 99 ? "99+" : String(count);
  return (
    <Box
      component="span"
      aria-label={label ?? `${count} new`}
      style={{
        minWidth: 18,
        height: 18,
        paddingInline: 5,
        borderRadius: 9999,
        backgroundColor: "#DC2626",
        color: "#ffffff",
        fontSize: 11,
        fontWeight: 800,
        lineHeight: "18px",
        textAlign: "center",
        boxSizing: "border-box",
        flexShrink: 0,
        boxShadow: "0 0 0 2px #ffffff",
        ...(floating ? { position: "absolute", top: 2, right: 2, zIndex: 2 } : { display: "inline-block" }),
        ...style,
      }}
    >
      {text}
    </Box>
  );
}
